import React from 'react'
import { TermSectionsAndEnrollmentsFeature } from '../../features/TermSectionsAndEnrollments'

const TermSectionsAndEnrollments: React.FC = (): JSX.Element => {
  return (
    <>
      <TermSectionsAndEnrollmentsFeature />
    </>
  )
}

export default TermSectionsAndEnrollments
